/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import type { Scope } from '@atlassian/search-client';

import SearchResource from './api/SearchResource';

export const createSearchProvider = (
	cloudId: string,
	scope: Scope,
	aggregatorUrl?: string,
	analyticsIdentifier?: string,
	useConfluenceTypeInAri?: boolean,
	// Ignored via go/ees005
	// eslint-disable-next-line @typescript-eslint/max-params
) => {
	return new SearchResource(
		cloudId,
		scope,
		aggregatorUrl,
		analyticsIdentifier,
		useConfluenceTypeInAri,
	);
};

export { SearchResource };
